// extracted by mini-css-extract-plugin
module.exports = {"Posts":"blog-module--Posts--157-m","Post":"blog-module--Post--2FPI3"};